import { render, staticRenderFns } from "./_accountPayable.vue?vue&type=template&id=2b029e0f&scoped=true&"
import script from "./_accountPayable.vue?vue&type=script&lang=js&"
export * from "./_accountPayable.vue?vue&type=script&lang=js&"
import style0 from "./_accountPayable.vue?vue&type=style&index=0&id=2b029e0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b029e0f",
  null
  
)

export default component.exports